var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-dialog',{attrs:{"show":_vm.show,"target-class":"modal__card--mini"},on:{"close":_vm.close}},[_c('product-added-to-cart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }